export const responseFlaws = [
  {
    slug: 'RESPONSE_SCHEMA_ISSUE',
    meaning: 'The response schema is missing or does not match the returned data.',
    detectionModes: ['classifier', 'code'],
    severity: 'medium',
    fixCategories: ['responseSchema'],
    repairPolicy: 'verified_review',
    verificationBaseMustSucceed: true,
    requiredEvidence: {
      observationIds: {
        type: 'stringArray',
        minItems: 1
      }
    },
    evidenceAlternatives: [
      {
        runSucceeded: {
          type: 'boolean',
          const: true
        },
        payloadShape: {
          type: 'string'
        },
        declaredAttributeCount: {
          type: 'integer',
          const: 0
        },
        schemaDynamic: {
          type: 'boolean',
          const: false
        }
      },
      {
        payloadShape: {
          type: 'string'
        },
        schemaPaths: {
          type: 'stringArray',
          minItems: 1
        },
        schemaMismatch: {
          type: 'string'
        }
      }
    ],
    verificationRecipe: ['schema derived from a real run; presentation keys valid against it.', 'schema matches a run; keys canonical; presentation valid.'],
    legacyCodes: ['RESPONSE_MAPPER_CONTRACT_FAILURE'],
    evidenceRelations: []
  },
  {
    slug: 'RESPONSE_EXTRACTION_ISSUE',
    meaning: 'The mapper selects or parses the wrong data, including a provider wrapper instead of its records.',
    detectionModes: ['classifier', 'code'],
    severity: 'high',
    fixCategories: ['responseSchema', 'executionContract'],
    repairPolicy: 'verified_review',
    verificationBaseMustSucceed: true,
    requiredEvidence: {
      observationIds: {
        type: 'stringArray',
        minItems: 1
      },
      configPaths: {
        type: 'stringArray',
        minItems: 1
      }
    },
    evidenceAlternatives: [
      {
        extractionFailureObserved: {
          type: 'boolean',
          const: true
        }
      },
      {
        retainedResourceWrapperObserved: {
          type: 'boolean',
          const: true
        }
      }
    ],
    verificationRecipe: ['settings keys within contract; extraction branch reachable; output contains resource records rather than a provider wrapper; verify affected actions that share the API mapper.'],
    legacyCodes: ['REQUEST_MAPPER_CONTRACT_FAILURE', 'RESPONSE_MAPPER_CONTRACT_FAILURE'],
    evidenceRelations: []
  },
  {
    slug: 'ERROR_DETECTION_ISSUE',
    meaning: 'Error detection is missing or classifies the provider outcome incorrectly.',
    detectionModes: ['classifier', 'code'],
    severity: 'high',
    fixCategories: ['errorDetection'],
    repairPolicy: 'verified_review',
    verificationBaseMustSucceed: false,
    requiredEvidence: {
      observationIds: {
        type: 'stringArray',
        minItems: 1
      }
    },
    evidenceAlternatives: [
      {
        configPaths: {
          type: 'stringArray',
          minItems: 1
        },
        providerOutcome: {
          type: 'string',
          enum: ['success', 'failure']
        },
        runtimeOutcome: {
          type: 'string',
          enum: ['success', 'failure']
        }
      },
      {
        errorDetectionConfigured: {
          type: 'boolean',
          const: false
        },
        providerOutcome: {
          type: 'string',
          enum: ['success', 'failure']
        },
        runtimeOutcome: {
          type: 'string',
          enum: ['success', 'failure']
        }
      }
    ],
    verificationRecipe: ['flat fields or working code; failing run classified correctly; success run not flagged.', 'detection configured; the observed failure classifies correctly.'],
    legacyCodes: ['RESPONSE_ERROR_DETECTION_CONTRACT_MISMATCH'],
    evidenceRelations: [
      {
        left: 'providerOutcome',
        operator: 'notEqual',
        right: 'runtimeOutcome'
      }
    ],
    codeEvidenceAlternatives: [
      {
        configPaths: {
          type: 'stringArray',
          minItems: 1
        },
        providerOutcome: {
          type: 'string',
          enum: ['success', 'failure']
        },
        runtimeOutcome: {
          type: 'string',
          enum: ['success', 'failure']
        }
      }
    ]
  }
];
